import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Verify from "./Verify"; // Import the Verify component
import Page2 from "./Page2";
import Page3 from "./Page3";
import Page4 from "./Page4";
import Page5 from "./Page5";

const Round = () => {
  const [counter, setCounter] = useState(0);
  const [rond, setRond] = useState(1);
  const [showVerification, setShowVerification] = useState(false);
  const [verificationState, setVerificationState] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const allResults = location.state.allResults;

  const incrementRoundAndCounter = () => {
    if (rond < 41) {
      setCounter((prevCounter) => (prevCounter + 1) % 4);
      if (counter === 3) {
        setRond((prevRound) => prevRound + 4);
        if (rond === 5) {
          setShowVerification(true);
        }
        if (rond === 9 && verificationState) {
          setRond(13); // Update round to 13
          setCounter(0); // Reset counter to 0
          setShowVerification(false); // Hide verification after successful verification
          setVerificationState(false); // Reset verification state
        }
        if (rond === 37) {
          navigate("/completed"); // Navigate to the "Completed" page
        }
      }
    }
  };

  const decrementRoundAndCounter = () => {
    if (rond > 1 || (rond === 1 && counter > 0)) {
      setCounter((prevCounter) => (prevCounter > 0 ? prevCounter - 1 : 3));
      if (counter === 0) {
        setRond((prevRound) => prevRound - 4);
        if (rond === 9) {
          setShowVerification(false);
          setVerificationState(false);
        }
      }
    }
  };

  const getPageComponent = () => {
    switch (counter) {
      case 0:
        return <Page2 round={rond} />;
      case 1:
        return <Page3 round={rond} />;
      case 2:
        return <Page4 round={rond} />;
      case 3:
        return <Page5 round={rond} />;
      default:
        return null;
    }
  };

  return (
    <>
      {showVerification ? (
        <Verify
          allResults={allResults}
          setVerificationState={setVerificationState}
          incrementRoundAndCounter={incrementRoundAndCounter}
          decrementRoundAndCounter={decrementRoundAndCounter}
        />
      ) : (
        <>
          {getPageComponent()}
          <div className="button-holder">
            <div className="prev-button" onClick={decrementRoundAndCounter}>
              PREVIOUS
            </div>
            <div className="next-button" onClick={incrementRoundAndCounter}>
              NEXT
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Round;
